import { render, staticRenderFns } from "./LeadInfo.vue?vue&type=template&id=a871497e&scoped=true&"
import script from "./LeadInfo.vue?vue&type=script&lang=js&"
export * from "./LeadInfo.vue?vue&type=script&lang=js&"
import style0 from "./LeadInfo.vue?vue&type=style&index=0&id=a871497e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a871497e",
  null
  
)

export default component.exports